export default "__VITE_ASSET__DR0z0eeG__"